import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { CustomerAdjustmentHistoryService } from '@/app/core/services/customer-adjustment-history/customer-adjustment-history.service';
import {
  GetCustomerAdjustmentHistoryAction,
  ClearCustomerAdjustmentHistoryAction,
} from './customer-adjustment-history.actions';
import { catchError, tap, throwError } from 'rxjs';
import { ICustomerAdjustmentHistory } from '@/app/core/interfaces/customer-adjustment-history.interface';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';

export interface CustomerAdjustmentHistoryStateModel {
  historyData: ICustomerAdjustmentHistory[];
  prediccionUuid: string | null;
}

export const initialState: CustomerAdjustmentHistoryStateModel = {
  historyData: [],
  prediccionUuid: null,
};

@State<CustomerAdjustmentHistoryStateModel>({
  name: 'customerAdjustmentHistory',
  defaults: initialState,
})
@Injectable()
export class CustomerAdjustmentHistoryState {
  @Selector() static getHistoryData(
    state: CustomerAdjustmentHistoryStateModel
  ): ICustomerAdjustmentHistory[] {
    return state?.historyData || [];
  }

  @Selector() static getPrediccionUuid(
    state: CustomerAdjustmentHistoryStateModel
  ): string | null {
    return state?.prediccionUuid || null;
  }

  constructor(
    private customerAdjustmentHistoryService: CustomerAdjustmentHistoryService,
    private dialog: MatDialog
  ) {}

  @Action(GetCustomerAdjustmentHistoryAction)
  GetCustomerAdjustmentHistoryAction(
    ctx: StateContext<CustomerAdjustmentHistoryStateModel>,
    { payload }: GetCustomerAdjustmentHistoryAction
  ) {
    ctx.patchState({
      prediccionUuid: payload.prediccionUuid,
    });

    return this.customerAdjustmentHistoryService
      .getCustomerAdjustmentHistory(payload)
      .pipe(
        tap(response => {
          ctx.patchState({ historyData: response });
        }),
        catchError(error => {
          this.dialog.open(EnovaAlertsComponent, {
            width: 'auto',
            data: {
              type: 'error',
              text:
                error?.error?.error ||
                error?.details ||
                error?.message ||
                'Ha ocurrido un error al obtener el historial de ajustes',
              hiddeCancelBtn: true,
            },
          });
          return throwError(() => error);
        })
      );
  }

  @Action(ClearCustomerAdjustmentHistoryAction)
  ClearCustomerAdjustmentHistoryAction(
    ctx: StateContext<CustomerAdjustmentHistoryStateModel>
  ) {
    ctx.setState(initialState);
  }
}
